"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.builtInFormatters = void 0;
var _moment = _interopRequireDefault(require("moment/moment"));
var _getLocale = _interopRequireDefault(require("../../utils/getLocale"));
const builtInFormatters = exports.builtInFormatters = {
  currencyFormat: function () {
    return function (text, render) {
      console.log(this);
      const locale = (0, _getLocale.default)(this.country, this.language);
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: this.mask
      }).format(render(text));
      return `<span>${formatted}</span>`;
    };
  },
  //#region DateFormats

  dateFormat_1: function () {
    return this.myDateFormat('MM/DD/YYYY');
  },
  dateFormat_custom: function (format) {
    return this.myDateFormat('');
  },
  dateFormat_2: function () {
    return this.myDateFormat('MMMM D, YYYY');
  },
  myDateFormat: function (format) {
    return function (text, render) {
      var dateString = render(text).replaceAll('-', '/');
      var dateObject = new Date(dateString);
      var outputString = (0, _moment.default)(dateObject).format(format);
      return outputString;
    };
  }

  //#endregion
};